import { createRouter, createWebHistory } from 'vue-router'
import Cookies from 'js-cookie';
import login from './login'
import project from './project'
import stage from './stage'
import company from './company'
import smeta from './smeta'
import task from './task';
import home from './home';
import work from './work';
import changelog from './changelog';
import wishes from './wishes';
import specialization from './specialization';
import payment from './payment';
import settings from './settings';
import warehouse from './warehouse';
import equipment from './equipment';
import users from './users';
import agent from './agent';
import files from './files';
import chat from './chat';

const routes = [
  ...login,
  ...project,
  ...stage,
  ...company,
  ...smeta,
  ...task,
  ...home,
  ...work,
  ...wishes,
  ...changelog,
  ...specialization,
  ...payment,
  ...settings,
  ...warehouse,
  ...equipment,
  ...users,
  ...agent,
  ...files,
  ...chat,
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const refCode = to.query.ref

  if (refCode) {
    localStorage.setItem('referral_code', refCode)
  }
  
  const isAuth = !!Cookies.get('access_token');

  if (to.meta.requiresAuth && !isAuth) {
    // нужно авторизоваться
    next('/login');
  } else if (to.meta.guestOnly && isAuth) {
    // уже авторизован, не пускаем на логин/регу
    next('/home'); // например, главная после логина
  } else {
    next();
  }
});

export default router
